/**
 * Icon Picker Component
 */

import { IBuilderComponent } from '../../base'
import { formatFromVariableText } from '../../format-utils'
import type { VariableTextValue } from '../../types'
import { deepMerge, parseToVariableText } from '../../parser-utils'
import iconPickerTemplate from './icon-picker.template.json'

export interface IIconPickerComponentSettings {
  // Data settings
  'icon-picker-data-value': string // Column ID
  'icon-picker-data-label': VariableTextValue
  // Behavior settings
  'icon-picker-behavior-required'?: boolean
}

export interface IIconPickerComponent extends IBuilderComponent {
  componentId: 'icon-picker'
  groupId: 'form'
  settings: IIconPickerComponentSettings
}

/**
 * Icon Picker AI Input
 */
export interface AiIconPickerInput {
  columnId: string // Required: maps to table column
  label?: string[] // Format: ["text:Select Icon"] or ["text:Choose ", "cr:iconType"]
  required?: boolean // Is this field required?
}

const ICON_PICKER_DEFAULT_TEMPLATE = iconPickerTemplate as unknown as IIconPickerComponentSettings

export class IconPickerComp {
  getTemplate(): IIconPickerComponentSettings {
    return ICON_PICKER_DEFAULT_TEMPLATE
  }

  /**
   * format icon picker component settings to AI icon picker input
   */
  format(settings: IIconPickerComponentSettings): AiIconPickerInput {
    const result: AiIconPickerInput = {
      columnId: settings['icon-picker-data-value'],
    }

    // Label
    const label = formatFromVariableText(settings['icon-picker-data-label'])
    if (label && label.length > 0) {
      result.label = label
    }

    // Required
    if (settings['icon-picker-behavior-required'] !== undefined) {
      result.required = settings['icon-picker-behavior-required']
    }

    return result
  }

  /**
   * parse AI icon picker input to icon picker component settings
   */
  parse(input: AiIconPickerInput): IIconPickerComponentSettings {
    const result = deepMerge(ICON_PICKER_DEFAULT_TEMPLATE, {})

    // Data - Column ID (required for form fields)
    if (input.columnId) {
      result['icon-picker-data-value'] = input.columnId
    }

    // Data - Label
    if (input.label) {
      result['icon-picker-data-label'] = parseToVariableText(input.label)
    }

    return result
  }
}

